import React, { useEffect, useState, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import Confetti from "react-confetti";
import "../styles/ThankYouPage.css";

// Custom hook to get window size
const useWindowSize = () => {
   const [size, setSize] = useState([0, 0]);
   useLayoutEffect(() => {
      function updateSize() {
         setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
   }, []);
   return { width: size[0], height: size[1] };
};

const ThankYouPage = () => {
   const location = useLocation();
   const name = new URLSearchParams(location.search).get("name") || "Driver";
   const [isAnimating, setIsAnimating] = useState(false);
   const { width, height } = useWindowSize();
   const [recycleConfetti, setRecycleConfetti] = useState(true);

   useEffect(() => {
      // Trigger the animation shortly after the component mounts
      const animationTimer = setTimeout(() => {
         setIsAnimating(true);
      }, 100);

      // After 4 seconds, stop recycling confetti, which lets the existing particles fall.
      const confettiTimer = setTimeout(() => {
         setRecycleConfetti(false);
      }, 4000);

      return () => {
         clearTimeout(animationTimer);
         clearTimeout(confettiTimer);
      };
   }, []);

   return (
      <div className="thank-you-page-container">
         <Confetti
            width={width}
            height={height}
            recycle={recycleConfetti}
            numberOfPieces={recycleConfetti ? 200 : 0}
            onConfettiComplete={() => setRecycleConfetti(false)}
         />
         <div className={`thank-you-card ${isAnimating ? "animate" : ""}`}>
            <div className="thank-you-header">
               <div className="success-icon-wrapper">
                  <svg
                     className="success-checkmark"
                     xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 52 52"
                  >
                     <circle
                        className="success-checkmark__circle"
                        cx="26"
                        cy="26"
                        r="25"
                        fill="none"
                     />
                     <path
                        className="success-checkmark__check"
                        fill="none"
                        d="M14.1 27.2l7.1 7.2 16.7-16.8"
                     />
                  </svg>
               </div>
               <h1 className="thank-you-title">Submission Received!</h1>
            </div>
            <div className="thank-you-body">
               <p>
                  Thank you, <strong>{name}</strong>!
               </p>
               <p>
                  Your verification details have been submitted successfully. We will review the
                  information and get back to you shortly.
               </p>
            </div>
         </div>
      </div>
   );
};

export default ThankYouPage;
